import React from "react";
import classNames from "classnames";
import { BemHelper } from "@/utils/BemHelper";
import { CirclePlusIcon } from "@/icons/primary/circle-plus-icon";
import defaultImage from "./images/default-product.jpeg";
import { useBreakpointValue } from "@/utils/index";

type Props = {
  onClick?: () => void;
  hasProducts?: boolean;
  image?: string;
  showImage: boolean;
};

const bem = new BemHelper("product-create-card-protec");

export const ProductCreateCardProtec: React.FC<Props> = ({
  hasProducts = true,
  image,
  showImage,
  onClick,
}) => {
  const isMobile = useBreakpointValue({ base: false, xs: true });

  return (
    <a className={classNames(bem.block())} onClick={() => onClick && onClick()}>
      {showImage && (
        <div className={classNames(bem.element("image"), isMobile && bem.element("image-mobile"))}>
          <img src={image || defaultImage} />
        </div>
      )}
      <div className={classNames(bem.element("content"))}>
        <div className={classNames(bem.element("call-to-action"))}>
          <CirclePlusIcon style={{ color: "black", stroke: "black" }} />
          <div className={classNames(bem.element("title"))}>
            {hasProducts ? "Add New Product" : "Add Your First Product"}
          </div>
        </div>
      </div>
    </a>
  );
};
